module.exports = __webpack_public_path__ + "img/alipay-alternative.3583b760.png";